import { RicosPluginToolbarNames } from 'ricos-types';
import { getAddButtons } from './getAddButtons.js';
import { getToolbarButtons } from './getToolbarButtons.js';
import { tiptapExtensions } from './tiptap/tiptap.js';
import { POLL_TYPE } from './types.js';
import { InsertModal } from './components/insert-modal/insert-modal.js';
import { SettingsModal } from './components/settings-modal/settings-modal.js';
import 'wix-rich-content-editor-common';
import './consts.js';
import 'ricos-schema';
import './assets/icons/InsertPluginIcon.js';
import 'react';
import '@wix/design-system';
import 'ricos-context';
import 'wix-rich-content-ui-components';
import './dataHooks.js';
import './components/insert-modal/preset-data.js';
import 'lodash';
import './defaults.js';
import './helpers.js';
import 'ricos-schema/next';
import 'wix-rich-content-common/libs/imageUtils';
import './components/insert-modal/preset-picker.js';
import './style-inject.es-e7b07dd7.js';
import './assets/icons/ListPollIcon.js';
import './assets/icons/WithImagePollIcon.js';
import './assets/icons/GridPollIcon.js';
import 'ricos-content';
import 'wix-rich-content-plugin-commons';
import './toolbar/PollDesignButton.js';
import 'wix-rich-content-toolbars-ui';
import './assets/icons/DesignIcon.js';
import './toolbar/PollLayoutButton.js';
import './toolbar/PollButtonsData.js';
import './assets/icons/LayoutGridIconNew.js';
import './assets/icons/LayoutListIconNew.js';
import './assets/icons/LayoutGridIcon.js';
import './tab-navigation-f3eb4402.js';
import './components/settings-modal/design-settings-section.js';
import './components/settings-modal/section.js';
import './assets/icons/ColorIcon.js';
import './assets/icons/GradientIcon.js';
import './assets/icons/ImageIcon.js';
import './components/settings-modal/layout-settings-section.js';
import './assets/icons/LayoutListIcon.js';
import './components/settings-modal/poll-settings-section.js';
import './toolbar/PollLayoutPanel.js';
import 'ricos-schema/dist/statics/poll.defaults.json';
import './tiptap/component.js';
import './viewer/poll-viewer.js';
import 'wix-rich-content-editor-common/libs/EditorEventsContext';
import './components/rce-helpers-context/index.js';
import 'prop-types';
import './viewer/poll-component.js';
import 'classnames';
import 'react-flip-move';
import 'react-measure';
import './components/poll-option/index.js';
import './components/poll-option/PollGridOption.js';
import 'wix-rich-content-common/libs/Tooltip';
import './RemoveOption-5414440c.js';
import './assets/icons/RemoveIcon.js';
import './components/poll-option/PollOptionBase.js';
import './components/poll-option/types.js';
import './components/poll-context/types.js';
import './assets/icons/NonEditableIcon.js';
import './assets/icons/CheckIcon.js';
import './components/image-upload/ImageUpload.js';
import './components/image-upload/types.js';
import './assets/icons/LoaderIcon.js';
import './assets/icons/ReplaceIcon.js';
import './components/text-field/TextField.js';
import './components/poll-option/PollListOption.js';
import './components/poll-option/webview/PollListOptionWebview.js';
import './option-webview-e9bd4b55.js';
import './components/poll-option/webview/PollGridOptionWebview.js';
import './components/poll-header/PollHeader.js';
import './components/poll-context/PollContext.js';
import './components/voted-users/VotedUsers.js';
import './components/voted-users/types.js';
import 'react-modal';
import './VotedUsersModal-bf00b37a.js';
import 'react-infinite-scroller';
import './components/voted-users/VoterAvatar.js';
import './components/voted-users/FallbackAvatar.js';
import './assets/icons/AddIcon.js';

const pluginPoll = (config) => {
  return {
    config: config != null ? config : {},
    type: POLL_TYPE,
    tiptapExtensions,
    getAddButtons: (config2, services) => getAddButtons(config2),
    toolbar: {
      names: [RicosPluginToolbarNames.POLL],
      getButtons: (config2, services) => getToolbarButtons(config2, services)
    },
    __exports: {
      InsertModal,
      SettingsModal
    }
  };
};

export { pluginPoll };
//# sourceMappingURL=editor.js.map
